<section>
  <ng-container
    *epcFeatureFlag="
      connectEnabledFlag;
      namespace: connectNamespace;
      equality: true;
      defaultValue: false
    "
  >
    <epc-connect-availability></epc-connect-availability>
  </ng-container>
  <div class="content">
    <epc-user-details></epc-user-details>
  </div>
</section>
@if (contactsUserMenu$ | async) {
<epc-business-contacts (showAll)="go('BusinessContacts')">
</epc-business-contacts>
}
<ng-container
  *epcFeatureFlag="
    connectEnabledFlag;
    namespace: connectNamespace;
    equality: true;
    defaultValue: false
  "
>
  <epc-connect-business-contacts
    (navigate)="go('UserContacts')"
  ></epc-connect-business-contacts>
</ng-container>
<epc-menu-active-accounts
  (navigate)="go('UserAccounts')"
></epc-menu-active-accounts>

<section>
  <div class="section-header d-flex align-items-center">
    <span class="text-muted" i18n="UserMenu@@userMenuUserlinksSubtitle"
      >User menu</span
    >
  </div>
  <div
    data-e2e="user-menu-container"
    class="content link-list d-flex flex-column align-items-center"
  >
    @for (link of links; track link) { @if (link.visible | async) {
    <a (click)="link.onClick()" class="w-100 d-flex" [attr.data-e2e]="link.e2e">
      <fa-icon [icon]="link.icon" class="user-menu-icon"></fa-icon>
      <span data-e2e="basket-manager-title" class="ml-3 font-weight-medium">{{
        link.label
      }}</span>
      @if (link.badge | async; as badge) {
      <atx-badge class="badge bg-{{ badge.type }} text-white ml-1">
        {{ badge.text }}
      </atx-badge>
      }
    </a>
    } }
  </div>
</section>

<section>
  <div class="section-header d-flex align-items-center">
    <span class="text-muted" i18n="UserMenu@@userMenuQuickSettingsSubtitle"
      >Quick settings
    </span>
  </div>
  <div class="content">
    <epc-quick-settings></epc-quick-settings>
  </div>
</section>

@if (version$ | async; as version) {
<section class="version-section">
  <div class="section-header d-flex justify-content-between flex-nowrap">
    <span class="text-muted" i18n="AppVersion@@userMenuAppVersion"
      >Version</span
    >
    <span
      ><fa-icon
        [atxTooltip]="copyVersionText"
        tooltipPlacement="top"
        [cdkCopyToClipboard]="version"
        (cdkCopyToClipboardCopied)="versionCopiedToClipboard($event)"
        (click)="$event.stopPropagation()"
        [icon]="['fas', 'clipboard']"
        class="btn p-0 px-1 text-muted version-icon"
      ></fa-icon>
      {{ version }}</span
    >
  </div>
</section>
}
